(() => {
  if (window.GoenchaOtayoriLoaded) return;
  window.GoenchaOtayoriLoaded = true;

  const REQUIRED_GROUPS = [
    'shop_rating',
    'purpose',
    'target_person',
    'selected_reason',
    'discovery_source'
  ];
  const LOCKED_RADIO_GROUPS = [
    'publish_permission'
  ];
  const SUBMIT_TIMEOUT_MS = 16000;
  const STATUS_TIMEOUT_MS = 8000;
  const STATUS_POLL_ATTEMPTS = 5;
  const STATUS_POLL_INTERVAL_MS = 700;
  const SENSITIVE_URL_PARAMS = [
    'email',
    'mail',
    'customer_email',
    'order',
    'order_number',
    'phone',
    'tel'
  ];
  const OTAYORI_PREVIEW_VIEW = 'goencha-otayori';
  const OTAYORI_CANONICAL_PATH = '/pages/goencha-otayori';

  const toArray = (value) => Array.prototype.slice.call(value || []);

  const hideThemeMobileMenuButton = () => {
    if (!document.documentElement.classList.contains('goencha-otayori-page') && !document.querySelector('.goencha-otayori')) return;

    toArray(document.querySelectorAll('.mobile-menu-button')).forEach((button) => {
      button.style.setProperty('display', 'none', 'important');
      button.style.setProperty('visibility', 'hidden', 'important');
      button.style.setProperty('opacity', '0', 'important');
      button.style.setProperty('pointer-events', 'none', 'important');
    });
  };

  const injectMobileSpacingStyle = () => {
    if (document.getElementById('goencha-otayori-mobile-spacing')) return;

    document.documentElement.classList.add('goencha-otayori-page');

    const style = document.createElement('style');
    style.id = 'goencha-otayori-mobile-spacing';
    style.textContent = '@media screen and (max-width: 1023px) {html.goencha-otayori-page body .site-header .header__top .mobile-menu-button, html.goencha-otayori-page body .mobile-menu-button { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }body:has(.goencha-otayori) .site-header .header__top .mobile-menu-button, body:has(.goencha-otayori) .mobile-menu-button { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }}@media screen and (max-width: 620px) {.goencha-otayori .goencha-otayori__fieldset { padding-top: 32px; padding-bottom: 30px; }.goencha-otayori .goencha-otayori__fieldset + .goencha-otayori__fieldset { padding-top: 42px; }.goencha-otayori fieldset.goencha-otayori__fieldset { padding-top: 0; }.goencha-otayori .goencha-otayori__fieldset + fieldset.goencha-otayori__fieldset { padding-top: 0; }.goencha-otayori fieldset.goencha-otayori__fieldset legend { padding-top: 32px; }.goencha-otayori .goencha-otayori__fieldset + fieldset.goencha-otayori__fieldset legend { padding-top: 42px; }}';
    document.head.appendChild(style);
    hideThemeMobileMenuButton();
  };

  const delay = (ms) => new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

  const createSubmissionId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'otayori_' + window.crypto.randomUUID();
    }

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      const values = new Uint32Array(4);
      window.crypto.getRandomValues(values);
      return 'otayori_' + toArray(values).map((value) => value.toString(36)).join('_');
    }

    return 'otayori_' + Date.now().toString(36) + '_' + Math.floor(Math.random() * 1000000000).toString(36);
  };

  const isSafeGasUrl = (value) => {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      return url.protocol === 'https:' &&
        url.hostname === 'script.google.com' &&
        url.pathname.indexOf('/macros/') === 0;
    } catch (error) {
      return false;
    }
  };

  const getCleanPageUrl = () => {
    try {
      const url = new URL(window.location.href);
      if (url.pathname.replace(/\/+$/, '') === '/pages' && url.searchParams.get('view') === OTAYORI_PREVIEW_VIEW) {
        url.pathname = OTAYORI_CANONICAL_PATH;
        url.search = '';
        url.hash = '';
        return url.toString();
      }
      SENSITIVE_URL_PARAMS.forEach((param) => url.searchParams.delete(param));
      return url.toString();
    } catch (error) {
      return window.location.origin + window.location.pathname;
    }
  };

  const setMessage = (root, text, type) => {
    const message = root.querySelector('[data-form-message]');
    if (!message) return;
    message.textContent = text || '';
    message.hidden = !text;
    message.classList.toggle('is-success', type === 'success');
  };

  const updateOtherFields = (root) => {
    root.querySelectorAll('[data-other-input]').forEach((wrapper) => {
      const key = wrapper.dataset.otherInput;
      const toggles = toArray(root.querySelectorAll('[data-other-toggle]'))
        .filter((input) => input.dataset.otherToggle === key);
      const active = toggles.some((input) => input.checked);
      wrapper.hidden = !active;
      if (!active) {
        wrapper.querySelectorAll('input, textarea').forEach((input) => {
          input.value = '';
        });
      }
    });

    const nickname = root.querySelector('[data-nickname-field]');
    if (nickname) {
      const checkedPermission = root.querySelector('input[name="publish_permission"]:checked');
      const active = checkedPermission && checkedPermission.value === 'ニックネームで掲載OK';
      nickname.hidden = !active;
      if (!active) {
        nickname.querySelectorAll('input').forEach((input) => {
          input.value = '';
        });
      }
    }
  };

  const updateChoiceStates = (root) => {
    root.querySelectorAll('.goencha-otayori__rating-card, .goencha-otayori__check').forEach((label) => {
      const input = label.querySelector('input');
      label.classList.toggle('is-selected', Boolean(input && input.checked));
    });
  };

  const validateForm = (root, form) => {
    let firstInvalid = null;
    let valid = true;
    let missingCount = 0;

    REQUIRED_GROUPS.forEach((name) => {
      const fieldset = root.querySelector(`[data-required-group="${name}"]`);
      const message = root.querySelector(`[data-required-message="${name}"]`);
      const inputs = toArray(form.querySelectorAll(`[name="${name}"]`));
      const hasValue = inputs.some((input) => input.checked);
      if (message) message.hidden = hasValue;
      if (fieldset) fieldset.classList.toggle('is-invalid', !hasValue);
      if (!hasValue) {
        valid = false;
        missingCount += 1;
        firstInvalid = firstInvalid || fieldset || inputs[0] || null;
      }
    });

    const email = form.querySelector('input[type="email"]');
    if (email && email.value && !email.checkValidity()) {
      valid = false;
      firstInvalid = firstInvalid || email;
      setMessage(root, 'メールアドレスの形式をご確認ください。', 'error');
    } else if (!valid) {
      setMessage(root, `未回答の必須項目があります（${missingCount}つ）。お手数ですが、印のついた項目をご確認ください。`, 'error');
    }

    if (firstInvalid && typeof firstInvalid.focus === 'function') {
      firstInvalid.focus({ preventScroll: true });
    }
    if (firstInvalid && typeof firstInvalid.scrollIntoView === 'function') {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return valid;
  };

  const postWithIframe = (endpoint, formData) => new Promise((resolve, reject) => {
    const iframeName = 'goencha_otayori_submit_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
    const iframe = document.createElement('iframe');
    const fallbackForm = document.createElement('form');
    let settled = false;
    let submitted = false;

    const cleanup = () => {
      window.setTimeout(() => {
        iframe.remove();
        fallbackForm.remove();
      }, 1200);
    };

    const done = () => {
      if (settled || !submitted) return;
      settled = true;
      cleanup();
      resolve({ ok: true });
    };

    iframe.name = iframeName;
    iframe.hidden = true;
    iframe.addEventListener('load', done);

    fallbackForm.method = 'POST';
    fallbackForm.action = endpoint;
    fallbackForm.target = iframeName;
    fallbackForm.hidden = true;

    formData.forEach((value, key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      fallbackForm.appendChild(input);
    });

    document.body.appendChild(iframe);
    document.body.appendChild(fallbackForm);

    window.setTimeout(() => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(new Error('iframe_timeout'));
    }, SUBMIT_TIMEOUT_MS);

    submitted = true;
    fallbackForm.submit();
  });

  const requestJsonp = (url, callbackPrefix) => new Promise((resolve, reject) => {
    const callbackName = callbackPrefix + '_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
    const script = document.createElement('script');
    let settled = false;

    const cleanup = () => {
      window[callbackName] = () => {};
      window.setTimeout(() => {
        delete window[callbackName];
      }, 1000);
      script.remove();
    };

    const timeoutId = window.setTimeout(() => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(new Error('jsonp_timeout'));
    }, STATUS_TIMEOUT_MS);

    window[callbackName] = (payload) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      cleanup();
      resolve(payload);
    };

    script.onerror = () => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      cleanup();
      reject(new Error('jsonp_error'));
    };

    url.searchParams.set('callback', callbackName);
    script.src = url.toString();
    document.head.appendChild(script);
  });

  const getSubmissionStatus = async (endpoint, submissionId) => {
    const url = new URL(endpoint);
    url.searchParams.set('mode', 'status');
    url.searchParams.set('submission_id', submissionId);
    return requestJsonp(url, 'goenchaOtayoriStatus');
  };

  const waitForSubmissionStatus = async (endpoint, submissionId) => {
    for (let attempt = 0; attempt < STATUS_POLL_ATTEMPTS; attempt += 1) {
      const payload = await getSubmissionStatus(endpoint, submissionId);
      if (!payload || payload.status !== 'pending') return payload;
      await delay(STATUS_POLL_INTERVAL_MS);
    }
    throw new Error('status_timeout');
  };

  const submitForm = async (endpoint, formData) => {
    const submissionId = String(formData.get('submission_id') || '');
    if (!submissionId) throw new Error('missing_submission_id');

    await postWithIframe(endpoint, formData);
    const status = await waitForSubmissionStatus(endpoint, submissionId);

    if (!status || status.ok !== true) {
      const error = new Error((status && status.message) || 'submit_failed');
      error.userMessage = status && status.message;
      throw error;
    }

    return status;
  };

  const initForm = (root) => {
    if (root.dataset.otayoriReady === 'true') return;
    root.dataset.otayoriReady = 'true';

    const form = root.querySelector('[data-otayori-form]');
    const success = root.querySelector('[data-success-screen]');
    const submitButton = root.querySelector('[data-submit-button]');
    const submitLabel = root.querySelector('[data-submit-label]');
    const defaultSubmitText = submitLabel ? submitLabel.textContent : '送信する';
    const endpoint = root.dataset.endpoint || '';
    if (!form) return;
    let radioToToggle = null;

    const params = new URLSearchParams(window.location.search);
    const orderValue = params.get('order') || '';
    const orderInput = form.querySelector('[data-order-number]');
    if (orderInput && orderValue) orderInput.value = orderValue.slice(0, 80);

    const submissionId = form.querySelector('[data-submission-id]');
    if (submissionId && !submissionId.value) submissionId.value = createSubmissionId();
    const startedAt = form.querySelector('[data-started-at]');
    if (startedAt && !startedAt.value) startedAt.value = String(Date.now());

    const pageUrl = form.querySelector('[data-page-url]');
    if (pageUrl) pageUrl.value = getCleanPageUrl();
    const userAgent = form.querySelector('[data-user-agent]');
    if (userAgent) userAgent.value = (window.navigator.userAgent || '').slice(0, 500);

    form.addEventListener('change', () => {
      updateOtherFields(root);
      updateChoiceStates(root);
      REQUIRED_GROUPS.forEach((name) => {
        const fieldset = root.querySelector(`[data-required-group="${name}"]`);
        const message = root.querySelector(`[data-required-message="${name}"]`);
        const inputs = toArray(form.querySelectorAll(`[name="${name}"]`));
        const hasValue = inputs.some((input) => input.checked);
        if (message && hasValue) message.hidden = true;
        if (fieldset && hasValue) fieldset.classList.remove('is-invalid');
      });
    });

    form.addEventListener('pointerdown', (event) => {
      const label = event.target.closest ? event.target.closest('label') : null;
      const input = event.target.matches && event.target.matches('input[type="radio"]')
        ? event.target
        : label && label.querySelector('input[type="radio"]');
      radioToToggle = input && input.checked && !LOCKED_RADIO_GROUPS.includes(input.name) ? input : null;
    }, true);

    form.addEventListener('click', (event) => {
      if (!radioToToggle) return;
      const label = event.target.closest ? event.target.closest('label') : null;
      const input = event.target.matches && event.target.matches('input[type="radio"]')
        ? event.target
        : label && label.querySelector('input[type="radio"]');
      if (input !== radioToToggle) {
        radioToToggle = null;
        return;
      }
      window.setTimeout(() => {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        radioToToggle = null;
      }, 0);
    }, true);

    updateOtherFields(root);
    updateChoiceStates(root);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      setMessage(root, '', 'error');
      if (!validateForm(root, form)) return;

      if (!isSafeGasUrl(endpoint)) {
        setMessage(root, '送信先のGAS WebアプリURLを設定してください。', 'error');
        return;
      }

      const formData = new FormData(form);
      if (submissionId && !submissionId.value) submissionId.value = createSubmissionId();
      formData.set('submission_id', submissionId ? submissionId.value : createSubmissionId());
      formData.set('started_at', startedAt && startedAt.value ? startedAt.value : String(Date.now()));
      formData.set('page_url', getCleanPageUrl());
      formData.set('user_agent', (window.navigator.userAgent || '').slice(0, 500));

      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = '送信しています';

      try {
        await submitForm(endpoint, formData);
        form.hidden = true;
        if (success) {
          success.hidden = false;
          success.focus({ preventScroll: true });
          success.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (error) {
        setMessage(root, error && error.userMessage ? error.userMessage : '送信できませんでした。時間をおいて、もう一度お試しください。', 'error');
      } finally {
        if (!form.hidden && submitButton) submitButton.disabled = false;
        if (!form.hidden && submitLabel) submitLabel.textContent = defaultSubmitText;
      }
    });
  };

  const setVoicesStatus = (root, text) => {
    const status = root.querySelector('[data-voices-status]');
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !text;
  };

  const createVoiceCard = (voice, showRating) => {
    const card = document.createElement('article');
    card.className = 'goencha-otayori-voices__card';

    if (voice.purpose) {
      const label = document.createElement('p');
      label.className = 'goencha-otayori-voices__label';
      label.textContent = voice.purpose;
      card.appendChild(label);
    }

    const comment = document.createElement('p');
    comment.className = 'goencha-otayori-voices__comment';
    comment.textContent = voice.comment || '';
    card.appendChild(comment);

    const name = document.createElement('p');
    name.className = 'goencha-otayori-voices__name';
    name.textContent = voice.display_name || '匿名のお客様';
    card.appendChild(name);

    if (showRating && voice.shop_rating) {
      const rating = document.createElement('p');
      rating.className = 'goencha-otayori-voices__rating';
      rating.textContent = voice.shop_rating;
      card.appendChild(rating);
    }

    return card;
  };

  const renderVoices = (root, payload) => {
    const list = root.querySelector('[data-voices-list]');
    if (!list) return;
    list.textContent = '';

    const voices = payload && payload.ok === true && Array.isArray(payload.voices)
      ? payload.voices
      : [];

    if (voices.length === 0) {
      setVoicesStatus(root, '掲載準備中です。');
      return;
    }

    setVoicesStatus(root, '');
    const showRating = root.dataset.showRating === 'true';
    voices.forEach((voice) => {
      list.appendChild(createVoiceCard(voice, showRating));
    });
  };

  const initVoices = (root) => {
    if (root.dataset.otayoriReady === 'true') return;
    root.dataset.otayoriReady = 'true';

    const baseUrl = root.dataset.jsonpUrl || '';
    if (!baseUrl) return;
    if (!isSafeGasUrl(baseUrl)) {
      setVoicesStatus(root, '公開用GAS URLを確認してください。');
      return;
    }

    const callbackName = 'goenchaOtayoriVoices_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
    const script = document.createElement('script');
    const url = new URL(baseUrl);
    url.searchParams.set('mode', 'voices');
    url.searchParams.set('limit', root.dataset.limit || '3');
    url.searchParams.set('callback', callbackName);

    window[callbackName] = (payload) => {
      renderVoices(root, payload);
      delete window[callbackName];
      script.remove();
    };

    script.onerror = () => {
      setVoicesStatus(root, 'お客様のおたよりを読み込めませんでした。');
      delete window[callbackName];
      script.remove();
    };

    script.src = url.toString();
    document.head.appendChild(script);
  };

  const init = () => {
    injectMobileSpacingStyle();
    window.addEventListener('scroll', hideThemeMobileMenuButton, { passive: true });
    window.setTimeout(hideThemeMobileMenuButton, 250);
    window.setTimeout(hideThemeMobileMenuButton, 1000);
    document.querySelectorAll('[data-goencha-otayori-form]').forEach(initForm);
    document.querySelectorAll('[data-goencha-otayori-voices]').forEach(initVoices);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
